<template lang="html">

  <section class="idioma row-start">
    <button @click="requestLangChange('es', false)" :active="lang == 'es'  && siteMexLang == false">ES</button>
    <button @click="requestLangChange('en', false)" :active="lang == 'en'">EN</button>
<!--     <button @click="requestLangChange('ja', false)" :active="lang == 'ja'">JP</button>
    <button @click="requestLangChange('ko' , false)" :active="lang == 'ko'">KO</button>
    <button @click="requestLangChange('ru', false)" :active="lang == 'ru'">RU</button> -->
    <button @click="requestLangChange('es', true)" v-if="siteMex" rel="noopener noreferrer" :active="lang == 'es' && siteMexLang == true">MX</button>
  </section>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

import router from '@/router';

export default {
  name: 'idioma',
  data() {
    return {
      oldLang: '',
      siteMex: false,
      siteMexLang: false
    }
  },
  mounted() {
    if (window.location.hostname.includes('.com.mx')  ){
      this.siteMex = true
      this.siteMexLang = true
    }
  },
  methods: {
    ...mapActions(['changeLanguage']),
    requestLangChange: function (lang, siteMex) {
      this.siteMexLang = siteMex
      this.oldLang = this.lang;

      this.changeLanguage(lang)

        .then(r => {
          this.$i18n.locale = r;
          this.changePath();
        }).catch(e => {
          console.log(e);
        })
    },
    changePath: function (lang) {

      let ispersonalizada = (this.$route.name.includes('_ficha'));

      if (!ispersonalizada) {
        router.push(this.texts.enlaces[this.$route.name]);
      } else {
        let clave = this.$route.name.split("_ficha")[0];

        let params = {
          "vino": "vino",
          "cava": "cava",
          "aceite": "aceite",
          "azafran": "azafran",
          "wine": "vino",
          "sparkling-wine": "cava",
          "olive-oil": "aceite",
          "saffron": "azafran",
        }

        if (clave == 'productos') {
          router.push(this.texts.enlaces[params[this.$route.params.id]]);
        } else {
          router.push(this.texts.enlaces[params[this.$route.params.id]] + this.texts.enlaces[clave]);
        }
      }

    }
  },
  computed: {
    ...mapGetters({
      lang: 'getLanguage',
      texts: 'getTexts',
      rawtexts: 'getrawtexts'
    })
  }
}
</script>

<style scoped lang="scss">
.idioma {
  margin-left: 10px;

  button,a {
    border: none;
    outline: none;
    padding: 5px 10px;
    background: none;
    border-right: 1px solid white;
    display: block;
    cursor: pointer;

    &:last-of-type {
      border-right: none;
    }

    &[active=true] {
      font-weight: 600;
    }
  }
  a{
    border-left: 1px solid white;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/idioma.vue